<template>
    <div class="app-container">

      <div class="box">

        <el-table size="small" current-row-key="id" :data="dataList" stripe highlight-current-row>
          <el-table-column prop="id" align="center" label="id"  width="50px"></el-table-column>
          <el-table-column prop="createIp" label="IP地址" align="center"></el-table-column>
          <el-table-column prop="createTime" label="下载时间" align="center"></el-table-column>

        </el-table>

        <!--分页组件-->
        <div class="pagination-container">

          <el-pagination
              class="pagiantion"

              @current-change="handleCurrentChange"

              :current-page="pagination.currentPage"

              :page-size="pagination.pageSize"

              layout="total, prev, pager, next, jumper"

              :total="pagination.total">

          </el-pagination>

        </div>

      </div>

    </div>

</template>


<script>
import axios from "@/axios";
export default {
  name: "counts",
  data() {
    return {
      dataList: {},
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.getdownloadlist();
    },
  methods: {
    getdownloadlist(){
      axios({
        method:"post",
        url:"/sys/app/download",
        data:{
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          orderField:"",
          order: "",
          keyword: ""
        }
      }).then(res=>{
        this.pagination.pageSize = res.data.data.size;
        this.pagination.currentPage = res.data.data.current;
        this.pagination.total = res.data.data.total;
        this.dataList = res.data.data.records
        // console.log("----------------------------------------------")
        // console.log(res.data.data.records)
      })
    },


      handleCurrentChange(currentPage) {
        //修改页码值为当前选中的页码值
        this.pagination.currentPage = currentPage;
        //执行查询
        this.getdownloadlist();
      },
  }
}

</script>

<style scoped>
.app-container{

  background: #fff;

  margin: 15px 30px 15px 15px;

}

.box {

  position: relative;

  border-radius: 3px;

  background: #ffffff;

  border-top: 3px solid #3c8dbc;

  padding: 10px;

  margin-bottom: 20px;

  width: 100%;

  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

}

.pagiantion{

  text-align: right;

  padding: 15px;

}
</style>
